import { Injectable } from "@angular/core";
import { filter, map, Observable } from "rxjs";
import { WebSocketService } from "./services/websocket.service";
import { Message } from "@shared/models/notifications/message";
import { MessageType } from "@shared/models/notifications/message-type";
import { MessagePurposeType } from "@shared/models/notifications/message-purpose-type";
import { MessageNotification } from "@shared/models/notifications/message-notification";

@Injectable({
    providedIn: 'root'
})
export class WebSocketFacade {

    constructor(private webSocketService: WebSocketService) {
    }

    openConnection() {
        this.webSocketService.openConnection();
    }

    authorizeConnection(token: string) {
        this.webSocketService.authorizeConnection(token);
    }

    // Send a message to the server
    sendMessage(message: any) {
        this.webSocketService.sendMessage(message);
    }

    // Receive messages from the server
    subscribeMessages() {
        return this.webSocketService.subscribeMessages()?.pipe(
            filter(message => {
                // process only messages with known notification type
                return Object.hasOwn(message, "type") && !!Object.keys(MessageType).find(t => t === message.type);
            }
        ));
    }

    // subscribe only messages with purpose == Notification
    subscribeNotificationMessages() {
        return this.subscribeMessages()?.pipe(
            filter(message => {
                // process only messages with purpose == Notification
                return Object.hasOwn(message, "purpose") && message?.purpose === MessagePurposeType.Notification;
            }),
            map(m => m as MessageNotification)
        );
    }

    // Close the WebSocket connection
    closeConnection() {
        this.webSocketService.closeConnection();
    }
}